import React from 'react'
import { useDispatch } from 'react-redux'
import { ButtonGroup, Button } from '@material-ui/core'

import LargeToolTip from '../../account/components/LargeToolTip'
import { EVENT_VIEW_TYPES } from '../../redux/events/reducers'
import actions from '../../redux/actions'
import { track, EVENTS } from '../../lib/tracking'

const ExpandedViewTypeButton = (props) => {
  const { onClick, disabled, key } = props
  // expanded view will be removed on jan 1 2022
  if (new Date().getTime() > new Date('2022/01/01').getTime()) {
    return null
  }
  const ButtonEl = (
    <Button
      key={`event view type key ${key}`}
      variant='contained'
      disabled={disabled}
      size='small'
      classes={{ root: 'button' }}
      onClick={onClick}
    >
      Expanded
    </Button>
  )
  // wrap button in span so that we don't give tooltip a disabled element
  return (
    <LargeToolTip title='This view will be removed in the future, try the other views'>
      {disabled ? <span>{ButtonEl}</span> : ButtonEl}
    </LargeToolTip>
  )
}

const EventViewTypeTabs = (props) => {
  const { viewType, eventsRequestPending } = props
  const dispatch = useDispatch()

  const handleSelectViewType = viewType => {
    track(EVENTS.EVENTS_VIEW_MODE, { mode: viewType })
    dispatch(actions.events.setEventViewType({ type: viewType }))
  }

  return (
    <ButtonGroup className='view-type-container'>
      {Object.keys(EVENT_VIEW_TYPES).map((key) => {
        const type = EVENT_VIEW_TYPES[key]
        const selected = viewType === key
        const buttonDisabled = selected || eventsRequestPending
        const onClick = () => handleSelectViewType(key)
        return key === EVENT_VIEW_TYPES.EXPANDED.key ? (
          <ExpandedViewTypeButton
            key={key}
            onClick={onClick}
            disabled={buttonDisabled}
          />
        ) : (
          <Button
            key={`event view type key ${key}`}
            variant='contained'
            disabled={buttonDisabled}
            size='small'
            classes={{ root: 'button' }}
            onClick={onClick}
          >
            {type.label}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

export default EventViewTypeTabs